export default __webpack_public_path__ + "static/media/ic_arbitrum_24.dd77229f.svg";